// noinspection JSUnusedGlobalSymbols

export const COLLABORATOR_COUNT_DESC_ID = 325
export const COMPANY_TYPE_DESC_ID = 327
export const SECTORS_DESC_ID = 314
export const AGREEMENT_TYPE_DESC_ID = 320
export const ROLE_DESC_ID = 250
export const BUILDING_DESC_ID = 364
